import Activity from '../../model/Activity'
import AppIcon from './AppIcon'
import MaskedIcon from './MaskedIcon'

interface ActivityIconProps {
  activity: Activity
  size?: number
  className?: string
  color?: string
}

export default function ActivityIcon({
  activity,
  size = 26,
  className,
  color,
}: ActivityIconProps) {
  const display = Activity.getDisplayIcon(activity)
  const tint = color ?? activity.getIconColor()

  if (display.type === 'iconify') {
    return <AppIcon icon={display.icon} size={size} className={className} style={{ color: tint }} />
  }

  if (display.src) {
    return <MaskedIcon src={display.src} size={size} color={tint} className={className} />
  }

  return null
}
